// Лидеры рейтинга — podium plus listă.
//
// La ei podiumul e primul lucru de pe pagină, iar restul e o listă cu căutare. Am păstrat
// ordinea: locul întâi trebuie să se vadă înainte să derulezi.

import { el, clear, bus } from '../core/util.js';
import { icon } from '../ui/icons.js';
import { session, initials } from '../core/session.js';

const MEDALII = ['🥇', '🥈', '🥉'];

export class LeaderboardSection {
  constructor(app) {
    this.app = app;
    this.items = [];
    this.search = '';
  }

  async mount(host) {
    this.root = el('div', { class: 'lb-section' });
    this.podiumEl = el('div', { class: 'lb-podium' });
    this.listEl = el('div', { class: 'lb-list' });

    this.root.append(
      el('div', { class: 'ideas-head' }, [
        el('h2', { class: 'ideas-title', text: 'Лидеры рейтинга' }),
        el('label', { class: 'auth-field lb-search' }, [
          icon('search', 12),
          el('input', {
            class: 'auth-input', placeholder: 'Поиск по нику…',
            oninput: (e) => { this.search = e.target.value.trim().toLowerCase(); this.#renderList(); },
          }),
        ]),
      ]),
      this.podiumEl,
      this.listEl,
    );
    host.append(this.root);
    await this.#load();
  }

  async #load() {
    try {
      const data = await (await fetch('/api/community/leaderboard?limit=100')).json();
      this.items = data.items || [];
    } catch {
      this.items = [];
    }
    this.#renderPodium();
    this.#renderList();
  }

  #renderPodium() {
    clear(this.podiumEl);
    // Podiumul are sens doar dacă cineva chiar a strâns rating; altfel e trei locuri goale.
    const top = this.items.filter((u) => u.rating > 0).slice(0, 3);
    if (!top.length) {
      this.podiumEl.append(el('div', { class: 'ideas-empty-sub lb-empty', text: 'Рейтинг ещё не набран — опубликуйте идеи, и подиум оживёт.' }));
      return;
    }
    // Ordinea vizuală: 2 — 1 — 3, ca pe un podium adevărat.
    const ordine = [1, 0, 2].filter((i) => top[i]);
    for (const i of ordine) {
      const u = top[i];
      this.podiumEl.append(el('button', {
        class: `lb-place p${i + 1}`,
        onclick: () => this.app.navigate(`/profile/${u.username}/`),
      }, [
        el('span', { class: 'lb-medal', text: MEDALII[i] }),
        el('span', { class: 'profile-avatar', text: initials(u.username), style: { background: u.status.color } }),
        el('span', { class: 'lb-nick', text: u.username, style: { color: u.status.color } }),
        el('span', { class: 'lb-rank', text: u.status.name }),
        el('span', { class: 'lb-rating', text: String(u.rating) }),
      ]));
    }
  }

  #renderList() {
    clear(this.listEl);
    const rows = this.items.filter((u) => !this.search || u.username.toLowerCase().includes(this.search));
    if (!rows.length) {
      this.listEl.append(el('div', { class: 'ideas-empty-sub', text: 'Никого не нашлось' }));
      return;
    }
    rows.forEach((u, i) => {
      const eu = session.user?.username === u.username;
      this.listEl.append(el('button', {
        class: `lb-row${eu ? ' me' : ''}`,
        onclick: () => this.app.navigate(`/profile/${u.username}/`),
      }, [
        el('span', { class: 'lb-pos', text: String(this.items.indexOf(u) + 1) }),
        el('span', { class: 'chat-avatar sm', text: initials(u.username), style: { background: u.status.color } }),
        el('span', { class: 'lb-nick', text: u.username, style: { color: u.status.color } }),
        u.role !== 'member' ? el('span', { class: 'chat-role', text: u.role === 'owner' ? 'Владелец' : 'Админ' }) : null,
        el('span', { class: 'lb-rank', text: u.status.name }),
        el('span', { class: 'lb-rating', text: String(u.rating) }),
      ]));
    });
  }

  unmount() {
    this.root?.remove();
  }
}
